export class AllianceCredential
{
    id: number;
    name: string;
    managementCompanyId: string;
    syncValidationFilesEnabled: boolean;

    constructor(ref) {
        this.id = ref.id;
        this.name = ref.name;
        this.managementCompanyId = ref.managementCompanyId;
        this.syncValidationFilesEnabled = ref.syncValidationFilesEnabled ?? false;
    }
}
